import { catalogControlsFromDocument, cloneCatalogControls } from "../catalogDocument.js";

export { setValueAt, valueAt } from "../catalogDocument.js";

export const cloneCodexControls = cloneCatalogControls;
export const codexControlsFromDocument = catalogControlsFromDocument;
export const composeCodexDocument = (controls) => JSON.parse(JSON.stringify(controls.document));
export const codexIncompleteLists = () => [];
export const codexDerivedValues = () => ({});
